import { GameUpdateData } from "@lib/titan2-slingo/dist/api/model/data/GameUpdateData";
import { ApiConstants } from "../enum/ApiConstants";
import { ExtendedSpinResultData } from "./ExtendedSpinResultData";
/**
* ExtendedGameUpdateData.ts
*/
export class ExtendedGameUpdateData extends GameUpdateData {
    solidifyResult() {
        let resultData = this.data.getDataObject(ApiConstants.PROPERTY_SPIN_RESULT);
        if (this.dataExists(resultData)) {
            this.result = new ExtendedSpinResultData(resultData);
        }
    }
}
//# sourceMappingURL=ExtendedGameUpdateData.js.map